import { Dispatch, ReactElement, SetStateAction, createContext, useEffect, useState } from 'react';
import { DateType } from '@/components/tachograph/diagram/TachographService';
import { FetchStatus } from '@/components/tachograph/diagram/TachographComponents';
import { MinimalTarget } from '@/generated/model';
import { TabValue } from '@/types';

export type TachographContextType = {
  tab: TabValue;
  setTab: Dispatch<SetStateAction<TabValue>>;
  status: FetchStatus;
  setStatus: Dispatch<SetStateAction<FetchStatus>>;
  selectedDates: DateType | undefined;
  setSelectedDates: Dispatch<SetStateAction<DateType | undefined>>;
  selectedTarget: MinimalTarget | undefined;
  setSelectedTarget: Dispatch<SetStateAction<MinimalTarget | undefined>>;
};

export const ctxTachographDiagram = createContext<TachographContextType | undefined>(undefined);

export function TachographDiagramContext({ children }: { children: ReactElement }) {
  const [status, setStatus] = useState<FetchStatus>('idle');
  const [selectedDates, setSelectedDates] = useState<DateType | undefined>(getLastTwoWeeks());
  const storedTachographTarget = getStoredTachographTarget();
  const [selectedTarget, setSelectedTarget] = useState<MinimalTarget | undefined>(storedTachographTarget);
  const [tab, setTab] = useState<TabValue>(
    storedTachographTarget !== undefined ? TabValue.result : TabValue.dateSelect
  );

  useEffect(() => {
    if (!selectedTarget) return;
    localStorage.setItem('tachographDiagram.target', JSON.stringify(selectedTarget));
  }, [selectedTarget]);

  function getLastTwoWeeks(): DateType {
    const today = new Date();
    const date14DaysAgo = new Date(today);
    date14DaysAgo.setDate(today.getDate() - 14);
    return { from: date14DaysAgo, to: today };
  }

  function getStoredTachographTarget(): MinimalTarget | undefined {
    const storedTachographTarget = localStorage.getItem('tachographDiagram.target');
    if (!storedTachographTarget || storedTachographTarget === 'undefined') return undefined;
    const targetId: MinimalTarget | undefined = JSON.parse(storedTachographTarget);
    return targetId;
  }

  return (
    <ctxTachographDiagram.Provider
      value={{
        tab,
        setTab,
        status,
        setStatus,
        selectedDates,
        setSelectedDates,
        selectedTarget,
        setSelectedTarget,
      }}
    >
      {children}
    </ctxTachographDiagram.Provider>
  );
}
